import { icons } from "../../icons";
import scale from "../../scale";
import styles from "./ErrorAlert.css";

interface ErrorAlertProps {
  id?: string;
  title: string;
  description?: string;
}

const ErrorAlert = ({ id, title, description }: ErrorAlertProps) => {
  const Icon = icons["info"];

  return (
    <div id={id} role="alert" className={styles.container}>
      <Icon
        aria-hidden="true"
        className={styles.icon}
        size={scale.spacing[24]}
      />
      <div>
        <p className={styles.title}>{title}</p>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};

export default ErrorAlert;
